import { defineComponent, computed, createVNode, reactive, provide, toRefs } from "vue";
import { getPrefixCls } from "../_utils/global-config.js";
import Spin from "../spin/index.js";
import usePropOrSlot from "../_utils/use-prop-or-slot.js";
import { cardInjectionKey } from "./context.js";
const SIZES = ["medium", "small"];
var _Card = defineComponent({
  name: "Card",
  components: {
    Spin
  },
  props: {
    bordered: {
      type: Boolean,
      default: true
    },
    loading: {
      type: Boolean,
      default: false
    },
    hoverable: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: "medium",
      validator: (value) => {
        return SIZES.includes(value);
      }
    },
    headerStyle: {
      type: Object,
      default: () => ({})
    },
    bodyStyle: {
      type: Object,
      default: () => ({})
    },
    title: {
      type: String
    },
    extra: {
      type: String
    }
  },
  setup(props, {
    slots
  }) {
    const prefixCls = getPrefixCls("card");
    const actionListRef = computed(() => {
      const actions = slots.actions && slots.actions();
      if (actions === void 0 || actions.length === 0) {
        return null;
      }
      return createVNode("div", {
        "class": `${prefixCls}-actions`
      }, [createVNode("div", {
        "class": `${prefixCls}-actions-right`
      }, [(actions || []).map((action, index) => createVNode("span", {
        "key": `action-${index}`,
        "class": `${prefixCls}-actions-item`
      }, [action]))])]);
    });
    const cardContext = reactive({
      hasMeta: false,
      hasGrid: false,
      actions: actionListRef.value
    });
    provide(cardInjectionKey, cardContext);
    const titleRef = usePropOrSlot(props, slots, "title");
    const extraRef = usePropOrSlot(props, slots, "extra");
    return {
      cardContext,
      slots,
      computedTitle: titleRef,
      computedExtra: extraRef,
      prefixCls,
      props
    };
  },
  render() {
    const {
      props,
      computedTitle,
      computedExtra,
      cardContext,
      prefixCls,
      slots
    } = this;
    const children = slots.default && slots.default();
    const {
      hasGrid,
      hasMeta,
      actions
    } = cardContext;
    const {
      bordered,
      loading,
      hoverable,
      size,
      headerStyle,
      bodyStyle
    } = toRefs(props);
    return createVNode("div", {
      "class": [prefixCls, `${prefixCls}-size-${size.value}`, {
        [`${prefixCls}-loading`]: loading.value,
        [`${prefixCls}-bordered`]: bordered.value,
        [`${prefixCls}-hoverable`]: hoverable.value,
        [`${prefixCls}-contain-grid`]: hasGrid
      }]
    }, [computedTitle || computedExtra ? createVNode("div", {
      "class": [`${prefixCls}-header`, {
        [`${prefixCls}-header-no-title`]: !computedTitle
      }],
      "style": headerStyle.value
    }, [computedTitle && createVNode("div", {
      "class": `${prefixCls}-header-title`
    }, [computedTitle]), computedExtra && createVNode("div", {
      "class": `${prefixCls}-header-extra`
    }, [computedExtra])]) : null, slots.cover ? createVNode("div", {
      "class": `${prefixCls}-cover`
    }, [slots.cover()]) : null, createVNode("div", {
      "class": `${prefixCls}-body`,
      "style": bodyStyle.value
    }, [loading.value ? createVNode(Spin, null, null) : children, hasMeta ? null : actions])]);
  }
});
export { SIZES, _Card as default };
